import { SpinLoading } from 'antd-mobile';
import * as React from 'react';

const PageLoading = () => {
  return (
    <div style={{ paddingTop: 100, display:'flex',justifyContent: 'center'}}>
      <SpinLoading color='primary'  style={{ '--size': '36px' }}/>
    </div>
  )
};

export default PageLoading;
